import * as actions from '../actions/actionTypes';
import initialState from './initialState';

/**
 * This reducer handles the LOAD_MASTER_DATA_MANAGEMENT_TRS_DATA_SUCCESS & LOAD_MASTER_DATA_MANAGEMENT_TRS_DATA_FAILURE action
 * and sets the property management data to the store
 * @param {Object} [state] The master data management TRS grid data
 * @param {Object} action The action to be handled
 * @returns {Object} The master data management TRS grid data
 */

export default function ownershipReducers(
  state = initialState.ownershipData,
  action
) {
  switch (action.type) {
    case actions.LOAD_OWNERSHIP_DATA_SUCCESS:
      // populate the uniqueKey for each item in the ownershipData array
      // if id is not available, generate a random number as uniqueKey
      return action.ownershipData.map((item) => ({
        ...item,
        uniqueKey:
          item.propertyId ??
          (parseInt(Math.random() * (99999999 - 1)) + 1) * -1,
      }));
    case actions.LOAD_OWNERSHIP_DATA_FAILURE:
      return state;
    default:
      return state;
  }
}
